module.exports = __webpack_public_path__ + "media/images/cog-85e0196053264104e03920ceab1c72ad.png";